// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2hHeC","messages":"Chat_messages__3zCrn","dateDivider":"Chat_dateDivider__ynkfu"};